import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Text,
} from "recharts";
import "../StackedBarChart/StackedBarChart.css";

const data = [
  { name: "Mon", volume: 900, orders: 800, profit: 600, loss: 1000 },
  { name: "Tue", volume: 1000, orders: 900, profit: 700, loss: 800 },
  { name: "Wed", volume: 1300, orders: 1100, profit: 900, loss: 750 },
  { name: "Thu", volume: 1200, orders: 1000, profit: 800, loss: 690 },
  { name: "Fri", volume: 1500, orders: 1200, profit: 1000, loss: 970 },
  { name: "Sat", volume: 1100, orders: 950, profit: 750, loss: 730 },
  { name: "Sun", volume: 1250, orders: 850, profit: 650, loss: 880 },
];

const CustomBarWithRadius = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 6; // Rounded corner radius
  return (
    <path
      d={`M${x},${y + radius} 
         a${radius},${radius} 0 0,1 ${radius},-${radius} 
         h${width - radius * 2} 
         a${radius},${radius} 0 0,1 ${radius},${radius} 
         v${height - radius} 
         h-${width} 
         Z`}
      fill={fill}
    />
  );
};

const StackedBarChart = () => {
  return (
    <>
      <section className="full-section">
        <div className="full-stacked-container">
          <div className="full-stacked-header">
            <h1>
              Weekly Performance Overview: Trading Volume, Orders, Profit, and
              Loss Trends <sub style={{color: "blue"}}>(Stacked Bar chart)</sub>
            </h1>
          </div>

          <div className="full-stacked-parent">
            <div className="full-stacked-chart-container">
              <ResponsiveContainer height={400}>
                <ComposedChart
                  data={data}
                  margin={{ top: 0, right: 0, left: 20, bottom: 40 }}
                >
                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={true}
                    vertical={false}
                  />
                  <XAxis
                    dataKey="name"
                    label={{
                      value: "Days of the Week",
                      position: "insideLeft", // Corrected position
                      offset: 0, // Adjust for spacing
                      style: { fontSize: "16px" }, // Updated font size
                      dy: 40,
                    }}
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated tick font size
                  />
                  <YAxis
                    label={{
                      value: "Count (Units)",
                      angle: -90,
                      position: "insideBottom",
                      offset: 40, // Simulates left margin
                      style: { fontSize: "16px" }, // Updated font size
                      dx: -35,
                    }}
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated tick font size
                  />
                  <Tooltip
                    labelStyle={{
                      fontWeight: "bold",
                      fontSize: "16px", // Updated label font size
                      color: "#000",
                    }}
                    itemStyle={{
                      color: "#999",
                      fontSize: "16px", // Updated item font size
                    }}
                    wrapperStyle={{
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  />
                  <Bar
                    dataKey="volume"
                    stackId="a"
                    fill="#5662be"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                  />
                  <Bar
                    dataKey="orders"
                    stackId="a"
                    fill="#7a86df"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                  />
                  <Bar
                    dataKey="profit"
                    stackId="a"
                    fill="#b0b8f4"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                  />
                  <Bar
                    dataKey="loss"
                    stackId="a"
                    fill="#f8e6bf"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                    shape={<CustomBarWithRadius />}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
            <div className="full-stacked-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                  <td>Legend</td>
                  <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#5662be" }}
                      ></i>
                    </td>
                    <td>Volume</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#7a86df" }}
                      ></i>
                    </td>
                    <td>Orders</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#b0b8f4" }}
                      ></i>
                    </td>
                    <td>Profit</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#f8e6bf" }}
                      ></i>
                    </td>
                    <td>Loss</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StackedBarChart;
